import { useEffect } from "react";
import api from "../lib/api";

// Best-effort copy/paste deterrent for the testing phase. When the Super-Admin
// enables "block_copy", customers (non-super) have selection, copy, cut and the
// context menu disabled site-wide, except inside form fields.
export default function CopyGuard() {
  useEffect(() => {
    let cleanup = () => {};
    api.get("/platform/flags").then((r) => {
      if (!r.data?.block_copy) return;
      const inField = (el) => el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
      const block = (e) => { if (!inField(e.target)) { e.preventDefault(); return false; } };
      document.addEventListener("copy", block);
      document.addEventListener("cut", block);
      document.addEventListener("contextmenu", block);
      const style = document.createElement("style");
      style.setAttribute("data-copyguard", "1");
      style.innerHTML = `body { -webkit-user-select: none; -moz-user-select: none; user-select: none; }
        input, textarea, [contenteditable="true"] { -webkit-user-select: text !important; user-select: text !important; }`;
      document.head.appendChild(style);
      cleanup = () => {
        document.removeEventListener("copy", block);
        document.removeEventListener("cut", block);
        document.removeEventListener("contextmenu", block);
        style.remove();
      };
    }).catch(() => {});
    return () => cleanup();
  }, []);
  return null;
}
